import { render, staticRenderFns } from "./ThgTerms.vue?vue&type=template&id=82d56086&scoped=true&"
import script from "./ThgTerms.vue?vue&type=script&lang=ts&"
export * from "./ThgTerms.vue?vue&type=script&lang=ts&"
import style0 from "./ThgTerms.vue?vue&type=style&index=0&id=82d56086&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82d56086",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VAlert,VCard,VCardSubtitle,VCardText,VCardTitle,VContainer,VSheet})
